import * as platform from 'platform';
import Main from "./page/Main";
import Planet from "./three/Planet";
import React from 'react';
import State from './store/State';

type AppState = {
  isPortrait: boolean;
};

const isPortrait = (): boolean => window.innerHeight > window.innerWidth;

/** Телефоны и планшеты, включая iPadOS 13+ (platform.os.family = 'OS X'). */
const isMobileOs = (): boolean => {
  const family = platform.os?.family ?? '';
  if (family === 'iOS' || family === 'Android') return true;

  // iPadOS 13+: Safari отдаёт 'OS X' / 'macOS', но с multi-touch
  return (
    (family === 'OS X' || family === 'macOS') &&
    navigator.maxTouchPoints > 1
  );
};

const portraitOverlay = (
  <div style={{
    color: '#fFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 9999,
    background: '#000',
  }}>
    <span>Поверните устройство в горизонтальное положение</span>
  </div>
);

class App extends React.Component<{}, AppState> {
  state: AppState = {
    isPortrait: isPortrait(),
  };

  private _mobile = isMobileOs();

  private _onWindowResize = (): void => {
    Planet.start();
    const portrait = isPortrait();
    if (portrait !== this.state.isPortrait) {
      this.setState({ isPortrait: portrait });
    }
  };

  /** На телефонах раньше layout сбрасывался reload при resize; без этого после поворота остаётся горизонтальный скролл. */
  private _onMobileOrientation = (): void => {
    window.location.reload();
  };

  componentDidMount(): void {
    if (this._mobile) {
      State.setIsMobile(true);
    }
    if (!this.state.isPortrait) {
      Planet.start();
    }
    window.addEventListener('resize', this._onWindowResize);
    if (this._mobile) {
      window.addEventListener('orientationchange', this._onMobileOrientation);
    } else {
      window.addEventListener('orientationchange', this._onWindowResize);
    }
  }

  componentDidUpdate(_prevProps: {}, prevState: AppState): void {
    if (prevState.isPortrait && !this.state.isPortrait) {
      Planet.start();
    }
  }

  componentWillUnmount(): void {
    window.removeEventListener('resize', this._onWindowResize);
    if (this._mobile) {
      window.removeEventListener('orientationchange', this._onMobileOrientation);
    } else {
      window.removeEventListener('orientationchange', this._onWindowResize);
    }
  }

  render() {
    if (this.state.isPortrait) {
      return portraitOverlay;
    }
    return <Main />;
  }
}

export default App;
